import makeService from './api';

export default makeService('software_versions');
